import React, { useMemo, useState, useEffect, useRef } from "react";
import { postData, getData, encodeId } from "../../../global/Globalapi";
// import { EMAILJS_CONFIG, getTemplateParams} from "../../../config/emailjs";
// import emailjs from '@emailjs/browser';
import ExcelHandler from './ExcelHandler';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import * as XLSX from "xlsx";
import swal from "sweetalert";

// --- Static templates (frontend only) ---
const STATIC_TEMPLATES = {
  default: {
    subject: "Welcome!",
    body: `<h2>Welcome!</h2><p>We are excited to share updates.</p>`
  }
};
const downloadSampleExcel = () => {
  // Sample data structure
  const sampleData = [
    { email: "user1@example.com", mobile: "9876543210", username: "John", usertype: "staff", userstatus: "active" },
    { email: "user2@example.com", mobile: "9876543222", username: "Priya", usertype: "guest", userstatus: "inactive" },
    { email: "aff1@example.com", mobile: "9998887777", username: "Affiliate", usertype: "affiliate", userstatus: "active" }
  ];

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(sampleData);

  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Recipients");

  // Trigger download
  XLSX.writeFile(workbook, "sample_recipients.xlsx");
};
const Input = ({ label, value, onChange, placeholder }) => (
  <div className="mb-4">
    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    <input
      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-500"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
    />
  </div>
);

const Select = ({ label, value, onChange, options }) => (
  <div className="mb-4">
    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    <select
      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-500"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

function formatMySQLDatetime(date) {
  const d = new Date(date);
  const pad = (n) => (n < 10 ? '0' + n : n);
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export default function EmailBroadcast() {
  const [broadcastName, setBroadcastName] = useState("");
  const [broadcastType, setBroadcastType] = useState("Email");
  const [selectedCampaignTypeId, setSelectedCampaignTypeId] = useState(null);
  const [subject, setSubject] = useState(STATIC_TEMPLATES.default.subject);
  const [message, setMessage] = useState("Hello! This is a test SMS.");
  const [html, setHtml] = useState(STATIC_TEMPLATES.default.body);
  const [imgUrl, setImgUrl] = useState("");
  const [targetUrl, setTargetUrl] = useState("");
  const [userstatus, setUserstatus] = useState("");
  const [usertype, setUsertype] = useState("");
  const [emailList, setEmailList] = useState("");
  const [phoneList, setPhoneList] = useState("");
  const [recipientCount, setRecipientCount] = useState("All");
  const [manualRecipients, setManualRecipients] = useState("");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);
  const [campaignTypes, setCampaignTypes] = useState([]);
  const [typeName, setTypeName] = useState("");
  const [typeDescription, setTypeDescription] = useState("");
  const [sendTime, setSendTime] = useState("");
  const recipientsRef = useRef(null);
  // const [part1, setpart1] = useState(true);
  // const [part2, setpart2] = useState(false);
  // const [part3, setpart3] = useState(false);
  // const [part4, setpart4] = useState(false);
const isAffiliate = (typeName || "").toLowerCase().includes("affiliate");
const [campaignNameError, setCampaignNameError] = useState("");
const [campaignId, setCampaignId] = useState(null);
const broadcastUserId = Number(localStorage.getItem("usertypeid"));
const [recipients, setRecipients] = useState([]);

const [part1, setPart1] = useState(true);
const [part2, setPart2] = useState(false);
const [part3, setPart3] = useState(false);
const [part4, setPart4] = useState(false);      
  const preview = useMemo(() => {
    return broadcastType === "Email"
      ? { __html: html }
      : { __html: `<p>${message}</p>` };
  }, [html, message, broadcastType]);
// const getAffiliateHTML = (link, campaign_id, USER_ID) => `
//   <h2>Hello!</h2>

//   <p>
//     We’re excited to invite you to join our Affiliate Program. Share our products
//     with your audience and earn commission for every order placed through your link.
//     It’s simple, fast, and a great way to make extra income.
//   </p>

//   <p>
//    <a href="http://localhost:3000/popup?campaign_id=${campaign_id}&affiliate_user_id=${{USER_ID}}&affiliate_campaign_id=&redirect_url=${encodeURIComponent(link)}"
//        style="
//           display:inline-block;
//           padding:10px 16px;
//           border-radius:6px;
//           background:#00aa00;
//           color:#fff;
//           text-decoration:none;
//        ">
//        Join the Affiliate Program
//     </a>
//   </p>

//   <p>
//     Need help? Reply to this email and our team will assist you.
//   </p>
// `;
// Auto-insert imgUrl into the email body
// returns a template with placeholders; pass the real redirect link (encoded)

const getAffiliateHTML = (redirectLink) => `
  <h2>Hello!</h2>

  <p>
    We’re excited to invite you to join our Affiliate Program. Share our products
    with your audience and earn commission for every order placed through your link.
    It’s simple, fast, and a great way to make extra income.
  </p>

  <p>
   <a href="http://localhost:3000/popup?campaign_id={{CAMPAIGN_ID}}&affiliate_user_id={{USER_ID}}&affiliate_campaign_id=&redirect_url=${(redirectLink)}"
       style="
          display:inline-block;
          padding:10px 16px;
          border-radius:6px;
          background:#00aa00;
          color:#fff;
          text-decoration:none;
       ">
       Join the Affiliate Program
    </a>
  </p>

  <p>Need help? Reply to this email and our team will assist you.</p>
`;
// const getAffiliateHTML = (redirectLink, encodedCampaignID, encodedUserID) => `
//   <h2>Hello!</h2>

//   <p>
//     We’re excited to invite you to join our Affiliate Program.
//   </p>

//   <p>
//    <a href="http://localhost:3000/popup?campaign_id=${encodedCampaignID}&affiliate_user_id=${encodedUserID}&affiliate_campaign_id=&redirect_url=${encodeURIComponent(redirectLink)}"
//        style="
//           display:inline-block;
//           padding:10px 16px;
//           border-radius:6px;
//           background:#00aa00;
//           color:#fff;
//           text-decoration:none;
//        ">
//        Join the Affiliate Program
//     </a>
//   </p>

//   <p>Need help? Reply to this email and our team will assist you.</p>
// `;

useEffect(() => {
  if (broadcastType !== "Email") return;

  // If affiliate → update CTA link (already handled)
  if (isAffiliate) {
    // setHtml(getAffiliateHTML(imgUrl));
    return;
  }

  // For normal emails → embed image inside the body
  if (imgUrl) {
    setHtml(`
      ${STATIC_TEMPLATES.default.body}
      <div style="margin-top:16px;">
        <img src="${imgUrl}" style="max-width:50%;border-radius:8px;" />
      </div>
    `);
  } else {
    setHtml(STATIC_TEMPLATES.default.body);
  }
}, [imgUrl, broadcastType, isAffiliate]);


  // Load only campaign types (keeping your existing backend for types)
  useEffect(() => {
    (async () => {
      try {
        const res = await getData("/campaigns/types");
        const types = res?.data?.data || [];
        setCampaignTypes(types);
        if (types.length > 0) {
          setTypeName(types[0].type_name);
          setTypeDescription(types[0].description || "");
        }
      } catch (err) {
        console.error("Error loading campaign types:", err);
      }
    })();
  }, []);

//   const getFilteredEmails = async () => {
//     try {
//       if (broadcastType === "Email" && (!subject || !html)) {
//         setResult({ success: false, message: "Please enter subject & body" });
//         return [];
//       }
//       const payload = { subject, html, filter: {} };
//       if (userstatus) payload.filter.userstatus = userstatus;
//       if (usertype) payload.filter.usertype = usertype;

//       const { data } = await postData("/email/broadcast", payload);
//       const recipients = JSON.parse(localStorage.getItem("recipients"));
// console.log("Stored Recipients:", recipients);

//        setRecipients(data.recipients || []); // ← SAVE WITH user_id
//     //   if (data.recipients) {
//     //   setRecipients(data.recipients);
//     // }
//       const emails = data.emails || [];
//       setEmailList(emails.length ? emails.join(", ") : "None");
//       return emails;
//     } catch (err) {
//       setResult({ success: false, message: err.message });
//       return [];
//     }
//   };


  // const getFilteredPhones = async () => {
  //   try {
  //     const { data } = await getData("/sms/test");
  //     const filtered = data.data.filter(
  //       (u) =>
  //         (!userstatus || u.userstatus === userstatus) &&
  //         (!usertype || u.usertype === usertype) &&
  //         u.mobile?.trim()?.length >= 10
  //     );
  //     setPhoneList(filtered.map((u) => u.mobile).join(", "));
  //     return filtered.map((u) => u.mobile);
  //   } catch (err) {
  //     setResult({ success: false, message: err.message });
  //     return [];
  //   }
  // };
  const getFilteredEmails = async () => {
  try {
    if (broadcastType === "Email" && (!subject || !html)) {
      setResult({ success: false, message: "Please enter subject & body" });
      return [];
    }
    const payload = { subject, html, filter: {} };
    if (userstatus) payload.filter.userstatus = userstatus;
    if (usertype) payload.filter.usertype = usertype;

    const { data } = await postData("/email/broadcast", payload);

    // save recipients (with user_id) into state and localStorage
    const recs = data.recipients || [];
    setRecipients(recs);
    try {
      localStorage.setItem("recipients", JSON.stringify(recs));
    } catch (err) {
      // ignore localStorage errors
      console.warn("Could not save recipients to localStorage", err);
    }

    const emails = data.emails || [];
    setEmailList(emails.length ? emails.join(", ") : "None");

    return emails;
  } catch (err) {
    setResult({ success: false, message: err.message });
    return [];
  }
};

const getFilteredPhones = async () => {
  try {
    const { data } = await getData("/sms/test");

    const filtered = data.data.filter((u) =>
      (!userstatus || u.status == userstatus) &&
      (!usertype || u.usertype == usertype) &&
      u.phone?.trim()?.length >= 10
    );

    setPhoneList(filtered.map((u) => u.phone).join(", "));
    return filtered.map((u) => u.phone);

  } catch (err) {
    setResult({ success: false, message: err.message });
    return [];
  }
};

  const previewEmails = async () => {
    setSending(true);
    const emails = await getFilteredEmails();
    setSending(false);
    if (emails.length) {
      setResult({ success: true, message: `Found ${emails.length} recipients` });
    }
  };

  const handleSaveSchedule = async () => {
    if (!selectedCampaignTypeId) {
      alert("Please select a broadcast type");
      return;
    }
    if (!broadcastName || !typeName) return alert("Fill all details");

    setSending(true);
    const payload = {
      type_name: typeName,
      description: typeDescription,
      campaign_type_id: selectedCampaignTypeId,
      campaign_name: broadcastName,
      subject: broadcastType === "Email" ? subject : null,
      template: broadcastType === "Email" ? html : message,
      image: imgUrl || null,
      target_url: targetUrl,
      start_date: sendTime || null,
      status: sendTime ? "Scheduled" : "Draft",
    };

    try {
      await postData("/campaigns/save", payload);
      alert("Campaign saved!");
      setResult({ success: true, message: "Saved successfully" });
    } catch (err) {
      console.error(err);
      alert("Error saving campaign");
    }

    setSending(false);
  };

//   const sendBroadcast = async () => {
//     if (!selectedCampaignTypeId) {
//       alert("Please select a broadcast type");
//       return;
//     }
//     if (broadcastType === "Email" && (!subject || !html)) {
//       alert("Please enter subject & HTML body");
//       return;
//     }

//     setSending(true);
//     setResult(null);

//     // STEP 1 — Load Recipients
//     let recipients = [];

//     if (recipientCount === "Manual") {
//       recipients = manualRecipients
//         .split(",")
//         .map((x) => x.trim())
//         .filter((x) => x);
//     } else {
//       if (broadcastType === "Email") {
//         if (!emailList) await getFilteredEmails();
//         recipients = emailList
//           .split(",")
//           .map((x) => x.trim())
//           .filter((x) => x.includes("@"));
//       } else {
//         if (!phoneList) await getFilteredPhones();
//         recipients = phoneList
//           .split(",")
//           .map((x) => x.trim())
//           .filter((x) => x.length >= 10);
//       }
//     }

//     if (recipientCount !== "All" && recipientCount !== "Manual") {
//       recipients = recipients.slice(0, Number(recipientCount));
//     }

//     if (!recipients.length) {
//       setResult({ success: false, message: "No valid recipients found" });
//       setSending(false);
//       return;
//     }

//     try {
//       // STEP 2 — Save Campaign
//       const saveCampaignPayload = {
//         type_name: typeName,
//         description: typeDescription,
//         campaign_type_id: selectedCampaignTypeId,
//         campaign_name: broadcastName,
//         subject: broadcastType === "Email" ? subject : null,
//         template: broadcastType === "Email" ? html : message,
//         image: imgUrl,
//         target_url: targetUrl,
//         start_date: formatMySQLDatetime(new Date()),
//         status: "Sent"
//       };

//       const saveCampaignRes = await postData("/campaigns/save", saveCampaignPayload);
//       const campaign_id = saveCampaignRes?.data?.campaignId;
//       if (!campaign_id) throw new Error("No campaign_id returned");
      
// // let finalHTML = `
// //   ${html}
// //   <div style="margin-top:15px;font-size:14px;color:#555;">
// //     <strong>Campaign ID:</strong> ${campaign_id}
// //   </div>
// // `;
// console.log("AFFILIATE DEBUG:", {
//   campaign_id,
//   broadcastUserId,
//   targetUrl
// });

//  const finalHTML = isAffiliate
//       ? getAffiliateHTML(targetUrl, campaign_id, broadcastUserId)
//       : `
//         ${html}
//         <div style="margin-top:15px;font-size:14px;color:#555;">
//           <strong>Campaign ID:</strong> ${campaign_id}
//         </div>
//       `;
// // recipients.forEach(rec => {
// //    const finalHTML = isAffiliate
// //         ? getAffiliateHTML(targetUrl, campaign_id, rec.user_id)
// //         : `
// //           ${html}
// //           <div style="margin-top:15px;font-size:14px;color:#555;">
// //             <strong>Campaign ID:</strong> ${campaign_id}
// //           </div>
// //         `;

// //    sendEmail(rec.email, subject, finalHTML);
// // });


// // STEP 4 — SEND EMAIL
// if (broadcastType === "Email") {
//   await postData("/send-broadcast/email", {
//     subject,
//     body: finalHTML,
//     filter: recipients
//   });
// }
//       // // STEP 3 — Save LEADS
//       // if (broadcastType === "Email") {
//       //   await postData("/campaign/leads/save", {
//       //     campaign_id,
//       //     affiliated_campaign_id: 0,
//       //     emails: recipients.map((email) => ({
//       //       email,
//       //       product_id: null,
//       //       category_id: null
//       //     }))
//       //   });
//       // } else {
//       //   await postData("/campaign/leads/save", {
//       //     campaign_id,
//       //     affiliated_campaign_id: 0,
//       //     phones: recipients.map((mobile) => ({
//       //       mobile,
//       //       product_id: null,
//       //       category_id: null
//       //     }))
//       //   });
//       // }

//       // STEP 4 — SEND
//       if (broadcastType === "Email") {
//         await postData("/send-broadcast/email", {
//           subject,
//           body: finalHTML,
//           filter: recipients
//         });
//       } 

//       else {
//         await postData("/send-broadcast/sms", {
//           message,
//           numbers: recipients
//         });
//       }

//       setResult({
//         success: true,
//         message:
//           broadcastType === "Email"
//             ? "✅ Campaign saved, leads recorded & emails sent!"
//             : "✅ Campaign saved, leads recorded & SMS sent!",
//         totals: {
//           recipients: recipients.length,
//           sent: recipients.length,
//           failed: 0
//         }
//       });
//     } catch (err) {
//       setResult({ success: false, message: "Error: " + err.message });
//     }

//     setSending(false);
//   };

  // const HandleParts = (p) => {
  //   setpart1(p === "part1");
  //   setpart2(p === "part2");
  //   setpart3(p === "part3");
  //   setpart4(p === "part4");
  // };
// const HandleParts = (section) => {
//   if (section === "part1") {
//     setPart1(!part1);
//   } 
//   else if (section === "part2") {

//     if (!broadcastName.trim()) {
//       setCampaignNameError("Campaign Name is required before proceeding.");
//       alert("Please enter the Campaign Name before continuing.");
//       return;
//     }

//     setCampaignNameError("");
//     setPart2(!part2);
//   } 
//   else if (section === "part3") {

//     if (!broadcastName.trim()) {
//       setCampaignNameError("Campaign Name is required before proceeding.");
//       alert("Please enter the Campaign Name before continuing.");
//       return;
//     }

//     setPart3(!part3);
//   }
// };
// const sendBroadcast = async () => {
//   if (!selectedCampaignTypeId) {
//     alert("Please select a broadcast type");
//     return;
//   }
//   if (broadcastType === "Email" && (!subject || !html)) {
//     alert("Please enter subject & HTML body");
//     return;
//   }

//   setSending(true);
//   setResult(null);

//   // STEP 1 — Load Recipients (emails string list) — keep previous behavior
//   let recipientEmails = [];

//   if (recipientCount === "Manual") {
//     recipientEmails = manualRecipients
//       .split(",")
//       .map((x) => x.trim())
//       .filter((x) => x);
//   } else {
//     if (broadcastType === "Email") {
//       if (!emailList) await getFilteredEmails();
//       recipientEmails = emailList
//         .split(",")
//         .map((x) => x.trim())
//         .filter((x) => x.includes("@"));
//     } else {
//       if (!phoneList) await getFilteredPhones();
//       recipientEmails = phoneList
//         .split(",")
//         .map((x) => x.trim())
//         .filter((x) => x.length >= 10);
//     }
//   }

//   if (recipientCount !== "All" && recipientCount !== "Manual") {
//     recipientEmails = recipientEmails.slice(0, Number(recipientCount));
//   }

//   if (!recipientEmails.length) {
//     setResult({ success: false, message: "No valid recipients found" });
//     setSending(false);
//     return;
//   }

//   try {
//     // STEP 2 — Save Campaign
//     const saveCampaignPayload = {
//       type_name: typeName,
//       description: typeDescription,
//       campaign_type_id: selectedCampaignTypeId,
//       campaign_name: broadcastName,
//       subject: broadcastType === "Email" ? subject : null,
//       template: broadcastType === "Email" ? html : message,
//       image: imgUrl,
//       target_url: targetUrl,
//       start_date: formatMySQLDatetime(new Date()),
//       status: "Sent"
//     };

//     const saveCampaignRes = await postData("/campaigns/save", saveCampaignPayload);
//     const campaign_id = saveCampaignRes?.data?.campaignId;
//     if (!campaign_id) throw new Error("No campaign_id returned");

//     // Build a mapping of email -> user_id from recipients state (populated by getFilteredEmails)
//     const recipientsMap = {};
//     (recipients || []).forEach(r => {
//       if (r && r.email) recipientsMap[r.email.trim()] = r.user_id;
//     });

//     // STEP 3 — Send one personalized email per recipient (to avoid [object Object] and 500)
//     let sent = 0, failed = 0;
//     for (const email of recipientEmails) {
//       // find user_id for this email (if available)
//       const userIdForThisEmail = recipientsMap[email] ?? null;

//       // build personalized HTML
//       const personalHTML = isAffiliate
//         ? getAffiliateHTML(targetUrl, campaign_id, userIdForThisEmail)
//         : `
//           ${html}
//           <div style="margin-top:15px;font-size:14px;color:#555;">
//             <strong>Campaign ID:</strong> ${campaign_id}
//           </div>
//         `;

//       try {
//         // send single email by sending filter with single address (your backend expects filter array)
//         await postData("/send-broadcast/email", {
//           subject,
//           body: personalHTML,
//            recipients ,
//           filter: [email]
//         });
//         sent++;
//       } catch (err) {
//         console.error("Send email error for", email, err);
//         failed++;
//         // continue sending to others
//       }
//     }

//     // STEP 4 — Save LEADS (unchanged behaviour; using all recipientEmails)
//     if (broadcastType === "Email") {
//       await postData("/campaign/leads/save", {
//         campaign_id,
//         affiliated_campaign_id: 0,
//         emails: recipientEmails.map((e) => ({ email: e, product_id: null, category_id: null }))
//       });
//     } else {
//       await postData("/campaign/leads/save", {
//         campaign_id,
//         affiliated_campaign_id: 0,
//         phones: recipientEmails.map((p) => ({ mobile: p, product_id: null, category_id: null }))
//       });
//     }

//     setResult({
//       success: failed === 0,
//       message: failed === 0 ? "✅ Campaign saved, leads recorded & emails sent!" : `Partially sent: ${sent} sent, ${failed} failed`,
//       totals: { recipients: recipientEmails.length, sent, failed }
//     });

//   } catch (err) {
//     console.error("sendBroadcast error:", err);
//     setResult({ success: false, message: "Error: " + err.message });
//   }

//   setSending(false);
// };
const sendBroadcast = async () => {
  if (!selectedCampaignTypeId) {
    alert("Please select a broadcast type");
    return;
  }
  if (broadcastType === "Email" && (!subject || !html)) {
    alert("Please enter subject & HTML body");
    return;
  }

  setSending(true);
  setResult(null);

  let recipientEmails = [];

  if (recipientCount === "Manual") {
    recipientEmails = manualRecipients
      .split(",")
      .map((x) => x.trim())
      .filter((x) => x);
  } else {
    if (broadcastType === "Email") {
      if (!emailList) await getFilteredEmails();
      recipientEmails = emailList
        .split(",")
        .map((x) => x.trim())
        .filter((x) => x.includes("@"));
    } else {
      if (!phoneList) await getFilteredPhones();
      recipientEmails = phoneList
        .split(",")
        .map((x) => x.trim())
        .filter((x) => x.length >= 10);
    }
  }

  if (recipientCount !== "All" && recipientCount !== "Manual") {
    recipientEmails = recipientEmails.slice(0, Number(recipientCount));
  }

  if (!recipientEmails.length) {
    setResult({ success: false, message: "No valid recipients found" });
    setSending(false);
    return;
  }

  try {
    // STEP 1 — SAVE CAMPAIGN
    const saveCampaignPayload = {
      type_name: typeName,
      description: typeDescription,
      campaign_type_id: selectedCampaignTypeId,
      campaign_name: broadcastName,
      subject: broadcastType === "Email" ? subject : null,
      template: broadcastType === "Email" ? html : message,
      image: imgUrl,
      target_url: targetUrl,
      start_date: formatMySQLDatetime(new Date()),
      status: "Sent"
    };

    const saveCampaignRes = await postData("/campaigns/save", saveCampaignPayload);
    const campaign_id = saveCampaignRes?.data?.campaignId;
    if (!campaign_id) throw new Error("No campaign_id returned");

    // STEP 2 — BUILD RECIPIENT OBJECT ARRAY (email + user_id)
    // const finalRecipients = recipientEmails.map(email => {
    //   const found = (recipients || []).find(r => r.email === email);
    //   return {
    //     email,
    //     user_id: found?.user_id ?? null
    //   };
    // });

// finalRecipients should come directly from "recipients" list
const finalRecipients = recipients
  .filter(r => recipientEmails.includes(r.email))  // only selected emails
  .map(r => ({
    email: r.email,
    user_id: r.user_id,
     encoded_user_id: btoa(String(r.user_id)),       // Base64 encoded
    encoded_campaign_id: btoa(String(campaign_id))  
  
  }));


console.log("📌 Sending to backend:", {
  subject,
  html,
  campaign_id,
  finalRecipients,
  isAffiliate
});

    // STEP 3 — CALL BACKEND ONLY ONCE (correct)
    // await postData("/send-broadcast/email", {
    //   subject,
    //   body: html,
    //   campaign_id,
    //   recipients: finalRecipients,   // <--- CORRECT
    //   isAffiliate
    // });
await postData("/send-broadcast/email", {
  subject,
  body: getAffiliateHTML(targetUrl),   // <-- template with placeholders
  campaign_id,
  recipients: finalRecipients,         // array of { email, user_id }
  isAffiliate
});

    // STEP 4 — SAVE LEADS
    if (broadcastType === "Email") {
      await postData("/campaign/leads/save", {
        campaign_id,
        affiliated_campaign_id: 0,
        emails: recipientEmails.map((e) => ({ email: e, product_id: null, category_id: null }))
      });
    } else {
      await postData("/campaign/leads/save", {
        campaign_id,
        affiliated_campaign_id: 0,
        phones: recipientEmails.map((p) => ({ mobile: p, product_id: null, category_id: null }))
      });
    }

    setResult({
      success: true,
      message: "✅ Campaign saved, leads recorded & emails sent!",
      totals: { recipients: finalRecipients.length }
    });

  } catch (err) {
    console.error("sendBroadcast error:", err);
    setResult({ success: false, message: "Error: " + err.message });
  }

  setSending(false);
};

const HandleParts = (section) => {
  if (section === "part1") {
    setPart1(!part1);
  } 
  else if (section === "part2") {

    if (!broadcastName.trim()) {
      setCampaignNameError("Campaign Name is required before proceeding.");

      swal({
        title: "Missing Campaign Name",
        text: "Please enter the Campaign Name before continuing.",
        icon: "warning",
        button: "OK",
      });

      return;
    }

    setCampaignNameError("");
    setPart2(!part2);
  } 
  else if (section === "part3") {

    if (!broadcastName.trim()) {
      swal({
        title: "Missing Campaign Name",
        text: "Please enter the Campaign Name before continuing.",
        icon: "warning",
        button: "OK",
      });

      return;
    }

    setPart3(!part3);
  }
  else if (section === "part4") {

    if (!broadcastName.trim()) {
      swal({
        title: "Missing Campaign Name",
        text: "Please enter the Campaign Name before continuing.",
        icon: "warning",
        button: "OK",
      });

      return;
    }

    setPart4(!part4);
  }
};


  return (
    <section className="w-full max-w-6xl mx-auto p-4 md:p-6 space-y-6">
      {/* Section 1: Broadcast Info */}
      <div className="bg-white shadow-sm border border-gray-200 rounded-lg">
        <h2
          className="text-xl font-semibold px-4 py-3 cursor-pointer rounded-t-lg"
          onClick={() => HandleParts('part1')}
        >
          1. Campaign
        </h2>

        {part1 && (
          <div className="px-4 py-3 border-t border-gray-200 rounded-b-lg">
            <Input
              label="Campaign Name"
              value={broadcastName}
              onChange={setBroadcastName}
              placeholder="Enter Campaign name"
            />

            <div className="p-3 border border-gray-200 rounded-lg mt-4">
              <h3 className="text-md font-semibold text-gray-800 mb-2">Campaign Type</h3>

              <Select
                label="Campaign Type"
                value={selectedCampaignTypeId || ''}
                onChange={(selectedId) => {
                  setSelectedCampaignTypeId(selectedId);
                  const selectedType = campaignTypes.find(
                    (ct) => ct.campaign_type_id === parseInt(selectedId)
                  );
                  setTypeName(selectedType?.type_name || '');
                  setTypeDescription(selectedType?.description || '');

                  const type = (selectedType?.type_name || "").toLowerCase();

                  // Static template assignment (no backend)
                  if (type.includes("affiliate")) {
                  setBroadcastType("Email");
                  setSubject("Affiliate Program!");

                  // init with empty or default link
                  const defaultLink = "https://your-affiliate-link";
                  setImgUrl(defaultLink);

                  // generate dynamic HTML
                  setHtml(getAffiliateHTML(defaultLink));
                   setUsertype("8");  
                }
                else if (type.includes("sms")) {
                    setBroadcastType("SMS");
                    setSubject("");
                    setHtml("");
                  } else {
                    setBroadcastType("Email");
                    setSubject(STATIC_TEMPLATES.default.subject);
                    setHtml(STATIC_TEMPLATES.default.body);
                  }
                }}
                options={[
                  { value: '', label: 'Select a campaign type' },
                  ...campaignTypes.map((ct) => ({
                    value: ct.campaign_type_id,
                    label: ct.type_name
                  }))
                ]}
              />

              <Input
                label="Description"
                value={typeDescription}
                onChange={setTypeDescription}
                placeholder="Auto-filled from DB or editable"
              />
            </div>
          </div>
        )}
      </div>

      {/* Section 2: Message Content */}
      <div className="bg-white shadow-lg border border-gray-200 rounded-xl overflow-hidden">
        <h2
          className="text-xl font-semibold px-6 py-4 bg-gray-50 cursor-pointer hover:bg-gray-100"
          onClick={() => HandleParts('part2')}
        >
          2. Message Content
        </h2>

        {part2 && (
          <div className="px-6 py-5 space-y-4 border-t border-gray-200">
            {/* 2) in Section 2: Message Content, inside the Email branch */}
            {broadcastType === 'Email' ? (
              <>
                <Input
                  label="Subject"
                  value={subject}
                  onChange={setSubject}
                  placeholder="Enter email subject"
                />

                {/* ⬇️ switch label & placeholder based on affiliate
                <Input
                  label={isAffiliate ? "Affiliate Link" : "Image URL (Optional)"}
                  value={imgUrl}
                  onChange={(val) => {
                    setImgUrl(val);
                    if (isAffiliate) setHtml(getAffiliateHTML(val)); // keep CTA href in sync
                  }}
                  placeholder={isAffiliate ? "https://your-affiliate-link" : "https://example.com/banner.png"}
                /> */}
{/* Show ONLY when not affiliate */}
{!isAffiliate && (
  <Input
    label="Image URL (Optional)"
    value={imgUrl}
    onChange={setImgUrl}
    placeholder="https://example.com/banner.png"
  />
)}

{/* ⬇️ switch label & placeholder based on affiliate */}
                <Input
                  label={isAffiliate ? "Affiliate Link" : "Target URL (Optional)"}
                  value={targetUrl}
                  onChange={(val) => {
                    setTargetUrl(val);
                    if (isAffiliate) setHtml(getAffiliateHTML(val)); // keep CTA href in sync
                  }}
                  placeholder={isAffiliate ? "https://your-affiliate-link" : "https://example.com/banner.png"}
                />

                <label className="block text-sm font-medium text-gray-700">Body (HTML supported)</label>
                {/* <textarea
                  className="w-full h-52 md:h-56 border border-gray-300 rounded-lg px-3 py-2 font-mono text-sm focus:ring-2 focus:ring-red-500"
                  value={html}
                  onChange={(e) => setHtml(e.target.value)}
                /> */}
                <CKEditor
                    editor={ClassicEditor}
                    data={html}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setHtml(data); // store HTML here
                    }}
                  />

              </>
            ) : (
              // SMS branch unchanged
              <>
                <label className="block text-sm font-medium text-gray-700">Message</label>
                <textarea
                  className="w-full h-52 md:h-56 border border-gray-300 rounded-lg px-3 py-2 font-mono text-sm focus:ring-2 focus:ring-green-500"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </>
            )}

          </div>
        )}
      </div>

      {/* Section 3: Recipients */}
      <div className="bg-white shadow-lg border border-gray-200 rounded-xl overflow-hidden">
        <h2
          className="text-xl font-semibold px-6 py-4 bg-gray-50 cursor-pointer hover:bg-gray-100"
          onClick={() => HandleParts('part3')}
        >
          3. Recipients
        </h2>

        {part3 && (
          <div className="px-6 py-5 space-y-4 border-t border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Select
                label="User Status"
                value={userstatus}
                onChange={setUserstatus}
                options={[
                  { value: '', label: 'All Statuses' },
                  { value: 'active', label: 'Active' },
                  { value: 'inactive', label: 'Inactive' }
                ]}
                
              />

              {/* <Select
                label="User Type"
                value={usertype}
                onChange={setUsertype}
                options={[
                  // { value: '', label: 'All Types' },
                  // { value: 'Admin', label: 'Admin' },
                  // { value: 'staff', label: 'Staff' },
                  // { value: 'guest', label: 'Guest' },
                  //    { value: 'affiliate', label: 'Affiliate' }   // ⬅️ Add this
                   { value: '', label: 'All Types' },
    { value: '1', label: 'Admin' },
    { value: '2', label: 'Seller' },
    { value: '3', label: 'Customer' },
    { value: '4', label: 'Staff' },
    { value: '5', label: 'Delivery agent' },
    { value: '6', label: 'Guest' },
    { value: '7', label: 'Google User' },
    { value: '8', label: 'Affiliate' },
                ]}
              />
               */}
               {/* If campaign = affiliate → show ONLY affiliate option */}
{isAffiliate ? (
  <Select
    label="User Type"
    value={usertype}
    onChange={setUsertype}
    options={[
      { value: '8', label: 'Affiliate' }
    ]}
  />
) : (
  <Select
    label="User Type"
    value={usertype}
    onChange={setUsertype}
    options={[
      { value: '', label: 'All Types' },
      { value: '1', label: 'Admin' },
      { value: '2', label: 'Seller' },
      { value: '3', label: 'Customer' },
      { value: '4', label: 'Staff' },
      { value: '5', label: 'Delivery agent' },
      { value: '6', label: 'Guest' },
      { value: '7', label: 'Google User' },
      { value: '8', label: 'Affiliate' },
    ]}
  />
)}

            </div>

            <Select
              label="Number of Recipients"
              value={recipientCount}
              onChange={async (value) => {
                setRecipientCount(value);
                let list = [];

                if (value !== 'Manual') {
                  if (broadcastType === 'Email') {
                    const emails = await getFilteredEmails();
                    list = value === 'All' ? emails : emails.slice(0, parseInt(value));
                    setEmailList(list.join(', '));
                  } else {
                    const phones = await getFilteredPhones();
                    list = value === 'All' ? phones : phones.slice(0, parseInt(value));
                    setPhoneList(list.join(', '));
                  }
                }
              }}
              options={[
                { value: 'All', label: 'All' },
                { value: '50', label: 'First 50' },
                { value: '100', label: 'First 100' },
                { value: '200', label: 'First 200' },
                { value: 'Manual', label: 'Manual Input' }
              ]}
            />

            {recipientCount === 'Manual' && (
              <Input
                label={broadcastType === 'Email' ? "Enter Emails (comma separated)" : "Enter Phone Numbers (comma separated)"}
                value={manualRecipients}
                onChange={setManualRecipients}
                placeholder={broadcastType === 'Email' ? "example@mail.com, ..." : "9876543210, ..."}
              />
            )}

            <label className="block text-sm font-medium text-gray-700">
              Recipient {broadcastType === 'Email' ? 'Email' : 'Phone'} List
              ({broadcastType === 'Email'
                ? emailList?.split(',').length
                : phoneList?.split(',').length} recipients)
            </label>

            <textarea
              className="w-full h-32 border border-gray-300 rounded-lg px-3 py-2"
              value={broadcastType === 'Email' ? emailList : phoneList}
              onChange={(e) => {
                if (broadcastType === 'Email') {
                  setEmailList(e.target.value);
                  setManualRecipients(e.target.value);
                } else {
                  setPhoneList(e.target.value);
                  setManualRecipients(e.target.value);
                }
                setRecipientCount("Manual");
              }}
            />

            {/* Show Excel upload only for Email or SMS campaigns and NOT for Affiliate types */}
            {(!isAffiliate && (broadcastType === 'Email' || broadcastType === 'SMS')) && (
              <ExcelHandler
                reference={recipientsRef}
                onImport={(emails) => {
                  setRecipientCount("Manual");
                  const existing = emailList ? emailList.split(",").map(e => e.trim()) : [];
                  const merged = Array.from(new Set([...existing, ...emails]));
                  setEmailList(merged.join(", "));
                  setManualRecipients(merged.join(", "));
                }}
              />
            )}

            <button
              onClick={broadcastType === 'Email' ? previewEmails : getFilteredPhones}
              disabled={sending}
              className="px-4 py-2 rounded border border-blue-300 hover:bg-blue-500"
            >
              {sending ? "Loading..." : "Filter Recipients"}
            </button>
            {!isAffiliate && (
              <button
                onClick={downloadSampleExcel}
                className="px-4 py-2 rounded bg-green-500 text-white hover:bg-green-600"
              >
                Download Sample Excel
              </button>
            )}

          </div>
        )}
      </div>

      {/* Section 4: Schedule & Send */}
      <div className="bg-white shadow-sm border border-gray-200 rounded-lg">
        <h2
          className="text-xl font-semibold px-4 py-3 cursor-pointer rounded-t-lg"
          onClick={() => HandleParts('part4')}
        >
          4. Schedule & Send
        </h2>

        {part4 && (
          <div className="px-4 py-3 border-t border-gray-200 rounded-b-lg">
            <Input label="Send Time" value={sendTime} onChange={setSendTime} placeholder="YYYY-MM-DD HH:MM" />

            <div className="flex gap-3 flex-wrap mt-2">
              <button
                onClick={handleSaveSchedule}
                disabled={sending}
                className={`px-5 py-2 rounded text-white ${sending ? 'bg-gray-400' : 'bg-green-600 hover:bg-green-700'}`}
              >
                {sending ? "Saving..." : "Save The Schedule"}
              </button>

              <button
                onClick={sendBroadcast}
                disabled={sending}
                className={`px-5 py-2 rounded text-white ${sending ? 'bg-gray-400' : 'bg-red-600 hover:bg-red-700'}`}
              >
                {sending ? "Sending..." : "Send Broadcast Now"}
              </button>

              <button
                onClick={() => {
                  setBroadcastName("");
                  setBroadcastType("Email");
                  setSubject(STATIC_TEMPLATES.default.subject);
                  setHtml(STATIC_TEMPLATES.default.body);
                  setImgUrl("");
                  setRecipientCount("All");
                  setManualRecipients("");
                  setEmailList("");
                  setResult(null);
                  setSendTime("");
                }}
                className="px-4 py-2 rounded border border-gray-300 hover:bg-gray-200"
              >
                Reset All
              </button>
            </div>

            {result && (
              <div className={`mt-3 p-3 rounded ${result.success ? "bg-green-50 text-green-800" : "bg-red-50 text-red-800"}`}>
                <div className="font-semibold">{result.message}</div>
                {result.totals && (
                  <div className="text-sm mt-1">
                    Recipients: {result.totals.recipients}, Sent: {result.totals.sent}, Failed: {result.totals.failed}
                  </div>
                )}
              </div>
            )}

            {/* 3) in the Live Preview box, show link for affiliate; image otherwise */}
          <div className="border rounded p-3 bg-gray-50 mt-2 max-h-48 overflow-auto">
            <strong>Live Preview:</strong>
            <div dangerouslySetInnerHTML={preview} />
           
            

          </div>

          </div>
        )}
      </div>
    </section>
  );
}
